export const ITEMS_GAP = 16;
//# sourceMappingURL=itemsGap.js.map